import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../data/atoms/utilsAtoms';

export const useAuth = () => {
	const userData = useAtomValue(userInfoAtom);
	return { isLoggedIn: userData.token ? true : false };
};
